(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("AddCompletedLearnersCtrl", ["learningItemSeminarsResource", "messageService", "data", "$uibModalInstance", addCompletedLearnersCtrl]);
    function addCompletedLearnersCtrl(learningItemSeminarsResource, messageService, data, $uibModalInstance) {
        var vm = this;
        vm.viewModel = learningItemSeminarsResource.getAddCompletedLearnersViewModel({ id: data.seminarId });
        vm.save = function (btn) {
            //EXAMPLE Disable button in repeater on click
            if (btn.target.disabled)
                return;
            btn.target.disabled = true;
            learningItemSeminarsResource.addCompletedLearners({ id: data.seminarId }, { learners: vm.learners, versionId: vm.version.id }, function () {
                $uibModalInstance.close();
            }, function (error) {
                messageService.error(error);
            });
        };
    }
}());
